var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex flex-col", attrs: { "data-id": _vm.panelId } },
    [
      _c(
        "div",
        {
          staticClass: "sticky top-0 z-10 flex flex-col bg-pure-white",
          attrs: { "data-id": _vm.panelId }
        },
        [
          _c(
            "div",
            {
              staticClass: "py-6 px-6 flex flex-col gap-2",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex items-center justify-between gap-4",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c("BlTextTitle4", {
                    attrs: {
                      "data-id": _vm.panelId,
                      text: "Scheduled sessions"
                    }
                  }),
                  _vm._v(" "),
                  _c("BlIcon", { attrs: { icon: "close", clickable: true } })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "px-6", attrs: { "data-id": _vm.panelId } },
            [
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { "data-id": _vm.panelId, text: "Showing" }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { "data-id": _vm.panelId, text: _vm.totalCount }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "text-slate-700",
                attrs: { "data-id": _vm.panelId, text: "scheduled session(s)" }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.fetchLoading
        ? _c(
            "div",
            {
              staticClass: "h-128 grid place-items-center",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("div", {
                staticClass: "blum-loader",
                attrs: { "data-id": _vm.panelId }
              })
            ]
          )
        : !_vm.scheduledSessions.length
        ? _c(
            "div",
            {
              staticClass: "px-16 h-128 grid place-items-center",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlTextBody1", {
                staticClass: "text-center",
                attrs: {
                  "data-id": _vm.panelId,
                  text:
                    "All sessions scheduled for this client will appear here."
                }
              })
            ],
            1
          )
        : _c(
            "div",
            {
              staticClass: "px-6 flex flex-col",
              attrs: { "data-id": _vm.panelId }
            },
            _vm._l(_vm.scheduledSessions, function(scheduled) {
              return _c(
                "div",
                {
                  key: scheduled.id,
                  staticClass:
                    "py-3 flex flex-col gap-2 border-b border-slate-400",
                  attrs: { "data-id": _vm.panelId }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-col gap-1 truncate",
                      attrs: { "data-id": _vm.panelId }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        attrs: {
                          "data-id": _vm.panelId,
                          text: "Session ID " + scheduled.session.id
                        }
                      }),
                      _vm._v(" "),
                      scheduled.user
                        ? _c(
                            "div",
                            {
                              staticClass: "truncate",
                              attrs: { "data-id": _vm.panelId }
                            },
                            [
                              _c("BlTextBody2", {
                                attrs: { "data-id": _vm.panelId, text: "With" }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                staticClass: "truncate",
                                class: { " italic": !scheduled.user.name },
                                attrs: {
                                  "data-id": _vm.panelId,
                                  title: scheduled.user.name || "deleted user",
                                  text: scheduled.user.name || "deleted user"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      scheduled.date
                        ? _c(
                            "div",
                            { attrs: { "data-id": _vm.panelId } },
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  "data-id": _vm.panelId,
                                  text: "Scheduled for"
                                }
                              }),
                              _vm._v(" "),
                              _c("BlTextBody2", {
                                attrs: {
                                  "data-id": _vm.panelId,
                                  text: _vm.displayDate({
                                    date: scheduled.date,
                                    format: "ddd DD MMM YYYY"
                                  })
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      scheduled.credit_transaction_service
                        ? _c("BlTextBody2", {
                            staticClass: "truncate",
                            attrs: {
                              "data-id": _vm.panelId,
                              title:
                                scheduled.credit_transaction_service
                                  .package_item_name,
                              text:
                                scheduled.credit_transaction_service
                                  .package_item_name
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !scheduled.appointment_credits.length
                        ? _c("BlTextBody2", {
                            attrs: {
                              "data-id": _vm.panelId,
                              text: scheduled.total_credit + " credit(s)"
                            }
                          })
                        : _c(
                            "div",
                            {
                              staticClass: "flex flex-col gap-1 truncate",
                              attrs: { "data-id": _vm.panelId }
                            },
                            [
                              _c(
                                "div",
                                { attrs: { "data-id": _vm.panelId } },
                                [
                                  _c("BlTextBody2", {
                                    attrs: {
                                      "data-id": _vm.panelId,
                                      text:
                                        scheduled.total_credit + " credit(s) of"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("BlTextBody2", {
                                    attrs: {
                                      "data-id": _vm.panelId,
                                      text:
                                        scheduled.appointment_credits[0]
                                          .credit_transaction_service
                                          .package_item.name + ":"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm._l(scheduled.appointment_credits, function(
                                credit
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: credit.id,
                                    staticClass: "px-2 flex items-center gap-2",
                                    attrs: { "data-id": _vm.panelId }
                                  },
                                  [
                                    _c("div", {
                                      staticClass:
                                        "h-1 w-1 flex-shrink-0 bg-slate-800 rounded",
                                      attrs: { "data-id": _vm.panelId }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { attrs: { "data-id": _vm.panelId } },
                                      [
                                        _c("BlTextBody2", {
                                          attrs: {
                                            "data-id": _vm.panelId,
                                            text:
                                              "ID " +
                                              credit.credit_transaction_service
                                                .credit_transaction_id +
                                              ":"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("BlTextBody2", {
                                          attrs: {
                                            "data-id": _vm.panelId,
                                            text:
                                              (credit.session_credit || 0) +
                                              " credit(s)"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              })
                            ],
                            2
                          )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.currentUser.role.includes("admin")
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            to: "/appointments/details/" + scheduled.id,
                            target: "_blank"
                          }
                        },
                        [
                          _c("BlInputButton", {
                            staticClass: "w-full",
                            attrs: {
                              type: "outlined",
                              dense: "",
                              title: "View appointment details",
                              label: "View details"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            }),
            0
          ),
      _vm._v(" "),
      _vm.totalCount > 25
        ? _c(
            "div",
            {
              staticClass: "px-6 flex justify-center mt-4 mb-36",
              attrs: { "data-id": _vm.panelId }
            },
            [
              _c("BlInputPagination", {
                attrs: {
                  dataId: _vm.panelId,
                  page: _vm.page,
                  count: Math.ceil(_vm.totalCount / _vm.perPage)
                },
                on: { changed: _vm.changePage }
              })
            ],
            1
          )
        : _c("div", { staticClass: "mb-46", attrs: { "data-id": _vm.panelId } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-202dcdbb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-202dcdbb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/creditTransaction/ScheduledSessionsPanel.vue
// module id = null
// module chunks = 